import React, { useState } from 'react';
import { InputGroup, FormControl } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faMinus, faPlus } from '@fortawesome/pro-solid-svg-icons';

library.add(faMinus, faPlus);

const NumberSelector = ({ value, max, label, parentCallback, min = 0 }) => {
    const [num, setNum] = useState(value);
    const inc = () => {
        if (num < max) {
            setNum(Number(num) + 1);
            parentCallback(num + 1);
        }
    };
    const dec = () => {
        if (num > min) {
            setNum(num - 1);
            parentCallback(num - 1);
        }
    };
    const handleChange = (e) => {
        setNum(e.target.value);
    };

    return (
        <div className='number-entries-field mt-4'>
            <InputGroup>
                <InputGroup.Prepend>
                    <button className='btn btn-primary decrement' type='button' onClick={dec}>
                        <FontAwesomeIcon icon='fa-solid fa-minus' />
                    </button>
                </InputGroup.Prepend>
                <FormControl className='input-field' value={num} onChange={() => handleChange} min={min} max={max} disabled={true} />
                <InputGroup.Append>
                    <button className='btn btn-primary increment' type='button' onClick={inc}>
                        <FontAwesomeIcon icon='fa-solid fa-plus' />
                    </button>
                </InputGroup.Append>
            </InputGroup>
            <div className='numbers-entry-label'>{label}</div>
        </div>
    );
};
export default NumberSelector;
